<!--集团简介-->
<template>
  <div class="about-box">
    <div class="page-banner flex-column-c-c">
      <div class="banner-title">集团简介</div>
      <div class="banner-line"></div>
    </div>
    <div class="about-tab flex-c-sa">
      <div class="tab-item flex-c-c" :class="currentTab === index ? 'active' : ''" v-for="(item,index) in tabList" :key="item.id" @click="handleTab(index,'currentTab')">{{item}}</div>
    </div>
    <!--集团简介-->
    <div class="w100per" v-show="currentTab === 0">
      <div class="intro-banner">
        <img class="w100per" src="../assets/about/about_banner.png" alt="">
      </div>
      <!--走进华夏营造-->
      <div class="intro-about-us flex">
        <div class="about-left">
          <div class="about-title">
            <div class="title-en">ABOUT US</div>
            <div class="title-sub">{{baseInfo.company_title}}</div>
          </div>
          <div class="about-intro" v-html="baseInfo.company_description"></div>
          <div class="about-total flex-c-sa">
            <div class="total-item">
              <div class="item-num">
                <span>{{baseInfo.company_scale}}</span>万
              </div>
              <div class="item-name">公司规模(2022)</div>
            </div>
            <div class="total-item">
              <div class="item-num">
                计划<span>{{baseInfo.company_plan}}</span>亿
              </div>
              <div class="item-name">公司规模(2023)</div>
            </div>
            <div class="total-item">
              <div class="item-num">
                <span>{{total.partner}}</span>家
              </div>
              <div class="item-name">合作伙伴</div>
            </div>
            <div class="total-item">
              <div class="item-num">
                <span>{{total.honor}}</span>个
              </div>
              <div class="item-name">荣誉资质</div>
            </div>
          </div>
        </div>
        <div class="about-right">
          <img class="img-cover" :src="ajaxUrl + baseInfo.company_image" alt="">
        </div>
      </div>
      <!--子公司介绍/公司书籍/论文-->
      <div class="about-book">
        <div class="book-title">子公司介绍</div>
        <div class="sub-list flex-c-sb">
          <router-link v-for="(item,index) in subList" :key="item.id" :to="`/subDetail?id=${item.id}`" class="sub-item flex" :class="index === currentSub ? 'on' : ''" @mouseover.native="handleSubHover(index,'currentSub')">
            <div class="item-default flex-column-s-c">
              <div class="default-tit flex-c-c">{{item.title_short}}</div>
              <div class="default-tit-full">{{item.title}}</div>
            </div>
            <div class="item-active">
              <div class="active-title">{{item.title}}</div>
              <div class="active-intro">{{item.description || item.title}}</div> 
            </div>
          </router-link>
        </div> 
        <div class="book-title">公司书籍 / 论文</div>
        <div class="book-red-block"></div>
        <div class="book-list flex">
          <router-link :to="`/bookDetail?id=${bookList[0].id}`" class="book-item web-book">
            <!--大图-->
            <div class="item-big">
              <img class="img-cover" :src="`${ajaxUrl}${bookList[0].image}`" alt="">
            </div>
          </router-link>
          <swiper class="flex-auto" ref="swiperCase" :options="swiperBook">
            <swiper-slide class="web-swiper" v-for="(item,index) in bookList" :key="index" v-if="index !== 0">
              <router-link :to="`/bookDetail?id=${item.id}`" class="book-item">
                <!--小图-->
                <div class="item-small">
                  <img class="img-cover" :src="`${ajaxUrl}${item.image}`" alt="">
                </div>
              </router-link>
            </swiper-slide>
            <swiper-slide class="app-swiper" v-for="(item,index) in bookList" :key="item.id">
              <router-link :to="`/bookDetail?id=${item.id}`" class="book-item">
                <!--小图-->
                <div class="item-small">
                  <img class="img-cover" :src="`${ajaxUrl}${item.image}`" alt="">
                </div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!--董事长简介-->
    <div class="leader-box" v-show="currentTab === 1">
      <div class="leader-title flex-column-c-c">
        <div class="title-text">董事长简介</div>
        <div class="title-line"></div>
      </div>
      <div class="leader-main flex">
        <div class="leader-intro">
          <div class="intro-content" v-html="baseInfo.culture_chairman_description"></div>
<!--          <div class="intro-title">-->
<!--            董事长简介 荀建 高级工程师-->
<!--          </div>-->
<!--          <div class="intro-title">-->
<!--            国家级传统建筑传承人-->
<!--          </div>-->
<!--          <div class="intro-content">-->
<!--            荀建 高级工程师<br>-->
<!--            国家级传统建筑传承人<br>-->
<!--            省级非物质文化遗产——山西传统寺观建筑营造技艺传承带头人<br>-->
<!--            山西省发改委建筑专家<br>-->
<!--            山西省收藏协会常务理事<br>-->
<!--            澳洲书画院副院长<br>-->
<!--            《筑苑》杂志社常务理事<br>-->
<!--            2012年被中国民族建筑研究会评为“中国民族建筑优秀企业家”<br>-->
<!--            荀建19岁起开始学习木工、瓦工技艺，基本掌握了传统木构建筑的营造技巧。九十年代后期跟随古建名家吴锐、张恩先学习，较为全面的掌握了古建调查测绘、设计制图、建筑营造等涉及的一系列知识，并开始由木工、瓦工向制图设计转变。<br>-->
<!--            董事长出版的书籍：<br>-->
<!--            1、《山西省浑源县神溪律吕神祠大殿修缮技术概论》见《建筑文化遗产的传承与发展论文集》<br>-->
<!--            2、《旧广武古城墙修缮保护工程述要》见《建筑文化遗产的传承与发展论文集》<br>-->
<!--            3、《浑源古城的价值特色与保护发展》见《山西古建》<br>-->
<!--            4、《大木构件安装施工报告》见《山西古建》<br>-->
<!--            5、《高平市炎帝陵拜殿大木构件制作与安装》见《山西古建》<br>-->
<!--            6、《荆庄大云寺大雄宝殿修缮工程》见《山西古建》<br>-->
<!--            7、《高平市神农镇炎帝陵施工报告》见《山西古建》<br>-->
<!--          </div>-->
        </div>
        <div class="leader-img">
          <div class="img-box">
            <img class="img-cover" :src="`${ajaxUrl}${baseInfo.culture_chairman_image}`" alt="">
          </div>
          <div class="img-text">
            {{baseInfo.culture_chairman_say}}
          </div>
          <div class="img-other">——荀建</div>
        </div>
      </div>
    </div>
    <!--企业文化-->
    <div class="about-culture" v-show="currentTab === 2">
      <div class="leader-title flex-column-c-c">
        <div class="title-text">企业文化</div>
        <div class="title-line"></div>
      </div>
      <div class="culture-box flex">
        <div class="cul-item">
          <div class="item-img"><img class="img-cover" :src="ajaxUrl + baseInfo.culture_idea_image" alt=""></div>
          <div class="item-con flex">
            <div class="con-left">
              <div class="font20">{{baseInfo.culture_idea_title}}</div>
              <div class="font16">IDEA</div>
            </div>
            <div class="con-text" v-html="baseInfo.culture_idea_description">
            </div>
          </div>
        </div>
        <div class="cul-item">
          <div class="item-con flex">
            <div class="con-left">
              <div class="font20">{{baseInfo.culture_spirit_title}}</div>
              <div class="font16">SPIRIT</div>
            </div>
            <div class="con-text" v-html="baseInfo.culture_spirit_description">
            </div>
          </div>
          <div class="item-img"><img class="img-cover" :src="ajaxUrl + baseInfo.culture_spirit_image" alt=""></div>
        </div>
      </div>
    </div>
    <!--在线留言-->
<!--    <MessageFrom></MessageFrom>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import Footer from "../components/Footer";
  import {ajaxGet, ajaxPost, ajaxUrl} from "../utils/ajax";
  export default {
    name: "About",
    components: {Footer, MessageFrom},
    data(){
      return {
        ajaxUrl,
        tabList:['集团简介','董事长简介','企业文化'],
        currentTab: 0,
        bookList:[],
        baseInfo: null,
        total: {},
        swiperBook: {
          slidesPerView: 3,
          spaceBetween: 11,
          grabCursor: true, // 抓手,
          slideToClickedSlide: true,
          watchSlidesVisibility: true, // 防止不可点击
        },
        subList:[],
        currentSub: 0,
      }
    },
    mounted() {
      this.$emit('handleRed', false);
      if(this.$route.query.type) {
        this.currentTab = this.$route.query.type - 1
      }
      this.fetchBase();
      this.fetchBook();
      this.fetchPartner();
      this.fetchHonor();
      this.fetchSub();
    },
    methods:{
      handleTab(ind,cur) {
        this[cur] = ind;
      },
      fetchPartner(){
        ajaxPost({
          url: 'ajaxPartner',
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.total = {
                ...this.total,
                partner: data.partner_list.length,
              };
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      fetchHonor(){
        ajaxPost({
          url: 'ajaxHonor',
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.total = {
                ...this.total,
                honor: data.honor_list.length,
              };
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      fetchBase(){
        ajaxGet({
          url: `${this.ajaxUrl}api/common/getConfig`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.bannerList = data.config_list.web_home_bg;
              this.baseInfo = data.config_list;
            }
          },
        },this);
      },
      fetchBook(){
        ajaxGet({
          url: `ajaxBook`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.bookList = data.book_list;
            }
          },
        },this);
      },
      fetchSub(){
        ajaxGet({
          url: `ajaxCompanyList`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.subList = data;
            }
          },
        },this);
      },
      handleSubHover(index,currentSub){
        console.log(4);
        this[currentSub] = index;
      },
    },
  }
</script>

<style scoped lang="scss">
  .about-box {
    width: 100%;background: #fff;
    .page-banner {
      width: 100%;height: 500px;background: url('../assets/about/case_banner.png') no-repeat center/cover;padding-top: 2%;
      .banner-title { font-size: 60px;color: $color-white;letter-spacing: 1px;}
      .banner-line { width: 110px;height: 3px;background: $color-white;margin-top: 50px;}
    }
    .about-tab {
      width: 100%;height: 113px;background: #F5F5F5;margin-top: 10px;
      .tab-item {
        font-size: $font-size16;color: $color-normal;height: 100%;padding:0 200px;cursor: pointer;
        &.active { background: $theme-color;color: $color-white;}
      }
    }
    .intro-banner {
      margin-top: 49px;padding: 0 29px;position: relative;z-index: 3;
    }
    .intro-about-us {
      width: 100%;background: url("../assets/about/about_us_bg.png") no-repeat top left;padding: 218px 110px 240px 110px;margin-top: -133px;position: relative;z-index: 2;
      .about-left {
        flex: 1 1 auto;margin-right: 60px;
        .title-en { font-size: 70px;color: $theme-color;}
        .title-sub { font-size: 50px;color: $theme-color;}
        .about-intro { margin-top: 60px;font-size: $font-size15;line-height: 1.9;color: $color-normal;letter-spacing: 1px;}
        .about-total {
          margin-top: 70px;text-align: center;background: $color-white;padding: 40px 0;
          .total-item {
            letter-spacing: 1px;
            .item-num {
              color: $theme-color;font-size: 20px;transition: .3s;
              span {
                font-weight: bold;font-size: 40px;transition: .3s;display: inline-block;
              }
            }
            &:hover .item-num span {
              animation: numRotateY linear .3s;
            }
            @keyframes numRotateY {
              0% {
                transform: rotateY(180deg);
              }
              100% {
                transform: rotateY(0deg);
              }
            }
            .item-name { font-size: 16px;margin-top: 20px;line-height: 1}
            &:first-child { margin-left: 0;}
          }
        }
      }
      .about-right {
        flex: 0 0 37%;height: 770px;overflow: hidden;
        img {
          transition: .5s;
          &:hover { transform: scale(1.2);}
        }
      }
    }
    .about-book {
      width: 100%;padding: 110px 110px 20px 110px;background: url("../assets/about/book_bg.png") no-repeat bottom left;
      margin-top: -246px;
      .book-title { font-size: 50px;color: $theme-color;position: relative;z-index: 3;}
      .book-red-block { margin-top: 80px;width: calc(100% + 7px);height: 358px;background: $theme-color;margin-left: -7px;}
      .book-list {
        width: 100%;position: relative;z-index: 2;
        .app-swiper { display: none;}
        .book-item {
          .item-big {
            width: 640px;height: 854px;margin-top: -400px;cursor: pointer;overflow: hidden;
            img {
              transition: .5s;
              &:hover { transform: scale(1.15)}
            }
          }
          .item-small {
            width: 310px;height: 430px;margin-top: 20px;margin-left: 40px;cursor: pointer;overflow: hidden;
            img {
              transition: .5s;
              &:hover { transform: scale(1.15)}
            }
          }
        }
      }
    }
    .leader-box {
      width: 100%;padding: 0 110px 106px 110px;
      .leader-main {
        width: 100%;color: $theme-color;
        .leader-intro {
          flex: 1 1 auto;padding: 10px 0;
          .intro-title { font-size: 30px;margin-top: 4px;word-spacing: 4px;letter-spacing: 1px;}
          .intro-content {font-size: $font-size18;margin-top: 30px;line-height: 1.8;}
        }
        .leader-img {
          flex: 0 0 50.7%;margin-left: 46px;
          .img-box {
            width: 100%;height: 640px;overflow: hidden;
            img { transition: .5s;&:hover { transform: scale(1.12);}}
          }
          .img-text { height: 90px;margin-top: 30px;font-size: 20px;font-family: '楷体';font-weight: bold;letter-spacing: .3px;}
          .img-other { height: 33px;font-size: 22px;font-family: '楷体';font-weight: bold;text-align: right;}
        }
      }
    }
    .leader-title {
      width: 100%;padding: 60px 0 90px 0;
      .title-text { font-size: 50px;color: $theme-color;}
      .title-line { width: 78px;height: 2px;background: $theme-color;margin-top: 10px;}
    }
    .about-culture {
      width: 100%;padding-bottom: 90px;
      .culture-box {
        width: 100%;padding: 0 160px;
        .cul-item {
          width: 45%;margin-right: 10%;
          .item-img {
            width: 100%;height: 330px;margin-bottom: 40px;overflow: hidden;
            img {
              transition: .5s;
              &:hover { transform: scale(1.15);}
            }
          }
          .item-con {
            .con-left {
              flex: 0 0 150px;height: 60px;padding-right: 28px;text-align: right;border-right: 1px solid $theme-color;margin-right: 32px;
              .font20 { letter-spacing: 2px;}
            }
            .con-text { font-size: $font-size14;line-height: 1.8;letter-spacing: 1px;}
          }
          &:nth-child(2n) {
            margin-right: 0;margin-top: 60px;
            .item-img { margin-top: 80px;}
            .con-left { height: 95px;}
          }
        }
      }
    }
    .sub-list {
      width: 100%;margin-top: 30px;z-index: 10;position: relative;margin-bottom:80px;
      .sub-item {
        width: 300px;background: url(../assets/about/sub_bg.png) #fff no-repeat right bottom;height:546px;margin-left: 0.84%;transition:.5s;overflow: hidden;
        &:first-child {margin-left: 0;}
        &.on { flex:1 1 auto;background-image: url(../assets/about/sub_bg_active.png);}
        .item-default { 
          padding: 100px 52px;width: 100%;
          .default-tit { margin: auto;width: 106px;height: 106px;background: #B3C8EB;font-size: 28px;color: #fff;padding: 10px 20px;border-radius: 6px;text-align: center;letter-spacing: 2px;}  
          .default-tit-full { font-size: 20px;color: $theme-color;margin-top: 28px;text-align: center;}  
        }
        .item-active { 
          padding: 50px 60px;color: #fff;display:none;
          .active-title { font-size: 20px;text-align: center;}
          .active-intro { font-size: 16px;margin-top: 60px;text-indent: 2em;opacity: 0;transition:.5s}
        }
        &.on .item-default { flex: 0 0 300px;}
        &.on .item-active { flex: 1 1 auto;display:block;}
        &.on .item-active .active-intro { opacity: 1;}
        &:nth-child(2n) .item-default .default-tit { background: #7AA9DD;}
        &:nth-child(3n) .item-default .default-tit { background: #7AA9DD;}
        &:nth-child(4n) .item-default .default-tit { background: #DC957D;}
      }
    }
  }
  @media screen and (max-width: 750px) {
    .about-box {
      width: 100%;
      .page-banner {
        height: 220px;padding-top: 5%;
        .banner-title { font-size: 30px;}
        .banner-line { width: 60px;height: 2px;margin-top: 14px;}
      }
      .intro-banner { margin-top: 20px;padding: 0 16px;}
      .about-tab {
        height: 40px;
        .tab-item { padding: 0;width: 33%;text-align: center;font-size: 14px;}
      }
      .intro-about-us {
        display: block;padding: 70px 20px 20px;margin-top: -60px;
        .about-left { width: 100%;}
        .about-title {
          .title-en { font-size: 36px;}
          .title-sub { font-size: 26px;margin-top: -10px;}
        }
        .about-left {
          .about-intro { margin-top: 20px;font-size: 14px;text-indent: 2em;}
          .about-total {
            flex-wrap: wrap;margin-top: 30px;padding: 10px 0;
            .total-item {
              width: 50%;padding: 10px 0;
              .item-num {
                font-size: 16px;
                span { font-size: 30px;}
              }
              .item-name { font-size: 14px;margin-top: 6px;}
            }
          }
        }
        .about-right { height: 200px;margin-top: 30px;}
      }
      .about-book {
        margin-top: 20px;padding: 2rem 20px;
        .book-title { font-size: 26px;}
        .book-red-block { margin: 20px 0 0 -10px;height: 150px;width: 100%;}
        .book-list {
          display: block;margin-top: -150px;
          .web-swiper { display: none;}
          .app-swiper { display: block;}
          .book-item {
            &.web-book { display: none;}
            .item-small {
              width: 100%;margin-left: 0;height: 146px;
            }
          }
        }
      }
      .leader-box {
        padding: 20px;width: 100%;
        .leader-title {
          padding: 10px 0;
          .title-text { font-size: 26px;}
          .title-line { width: 48px;margin-top: 5px;}
        }
        .leader-main {
          display: block;
          .leader-intro {
            width: 100%;
          }
          .leader-img {
            width: 100%;margin: 0;
            .img-box { height: 200px;}
            .img-text { height: auto;margin-top: 20px;font-size: 15px;}
            .img-other { font-size: 16px;height: auto;padding-right: 6px;margin: 10px 0;}
          }
          .leader-intro {
            .intro-content {
              font-size: 14px !important;margin-top: 5px;
              >>> .intro-title { font-size: 20px;span { font-size: 20px !important;}}
            }
          }
        }
      }
      .about-culture {
        padding: 20px;
        .leader-title {
          padding: 10px 0;
          .title-text { font-size: 26px;}
          .title-line { width: 48px;margin-top: 5px;}
        }
        .culture-box {
          padding: 0;display: block;margin-top: 16px;margin-bottom: 10px;
          .cul-item {
            width: 100%;margin-right: 0;
            .item-img { height: 150px;margin-bottom: 20px;}
            .item-con {
              display: block;
              .con-left { width: 150px;text-align: left;border-right: none;border-bottom: 1px solid $theme-color;height: auto;padding-bottom: 6px;margin-bottom: 14px;}
              .con-text { font-size: 12px;margin-top: 10px;}
            }
            &:nth-child(2) {
              padding-top: 170px;position: relative;margin-top: 26px;
              .item-img {
                position: absolute;top: 0;margin-top: 0;
              }
            }
          }
        }
      }
      .sub-list {
        width: 100%;margin-top: .3rem;z-index: 10;position: relative;margin-bottom: 3rem;flex-wrap:wrap;
        .sub-item {
          width: 48%;background: url(../assets/about/sub_bg.png) #fff no-repeat right bottom;background-size: 8rem auto;height:14rem;margin-left: 0.84%;transition:.5s;margin-top:1rem;
          &:first-child {margin-left: 0;}
          &.on { flex: 0 0 48%;background: url(../assets/about/sub_bg.png) #fff no-repeat right bottom;background-size: 8rem auto;}
          .item-default { 
            padding: 2rem 0.4rem;width: 100%;justify-content: flex-start;
            .default-tit { width: 4rem;height: 4rem;background: #B3C8EB;font-size: 1.2rem;color: #fff;padding: 0.5rem;border-radius: 6px;text-align: center;letter-spacing: 1px;line-height: 1.25;}  
            .default-tit-full { font-size: 1.02rem;color: $theme-color;margin-top: 1.2rem;text-align: center;height: 1.5rem;}  
          }
          .item-active { 
            display:none;
          }
          &.on .item-active { display: none;}
          &.on .item-default { flex: 0 0 100%;}
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/About.vue